import { useState, useEffect } from 'react';

export const useCountdown = (durationInMinutes: number) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const savedEndTime = localStorage.getItem('promoEndTime');
    if (savedEndTime) {
      const remaining = Math.max(0, Math.floor((parseInt(savedEndTime) - Date.now()) / 1000));
      return remaining > 0 ? remaining : durationInMinutes * 60;
    }
    return durationInMinutes * 60;
  });

  useEffect(() => {
    if (!localStorage.getItem('promoEndTime')) {
      const endTime = Date.now() + durationInMinutes * 60 * 1000;
      localStorage.setItem('promoEndTime', endTime.toString());
    }

    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          localStorage.removeItem('promoEndTime');
          return durationInMinutes * 60;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [durationInMinutes]);

  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;

  return {
    hours,
    minutes,
    seconds,
    timeLeft,
    formattedTime: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  };
};